import { useTranslation } from "react-i18next";
import { PartialFormData } from "../Form/FormControl";

interface EmailConfirmationProps extends PartialFormData{}

export const EmailConfirmation = (props: EmailConfirmationProps) => {
    const {email} = props;
    const { t } = useTranslation();

    const emailAssocDNS = (domain: string) => {
        switch (domain) {
            case 'gmail.com':
                return 'mail.google.com';
            case 'yahoo.com':
            case 'yahoo.de':
                return 'mail.yahoo.com';
            case 'outlook.com':
            case 'hotmail.com':
            case 'live.com':
                return 'outlook.live.com';
            case 'icloud.com':
            case 'me.com':
            case 'mac.com':
                return 'www.icloud.com/mail';
            case 'aol.com':
                return 'mail.aol.com';
            case 't-online.de':
                return 'email.t-online.de';
            case 'web.de':
                return 'web.de/mails';
            case 'gmx.de':
                return 'www.gmx.net/mail';
            case 'protonmail.com':
            case 'proton.me':
                return 'mail.proton.me';
            default:
                return domain;
        }
    }

    const domain = emailAssocDNS(email ? email.split('@')[1] : '');

    return (
        <div className="e-mail-confirmation">
            <div className="e-mail-confirmation-inner-container">
                <div className="icon-bg">
                    <span className="icon--ri mail-check-line font-size-2"></span>
                </div>
                <h2 className="text-align-center">{t('Dein Account wurde erstellt!')}</h2>
                <p className="text-align-center">{t('Wir haben dir deinen Login-Link an')} <strong>{email}</strong> {t('geschickt.')}</p>
                <div className="mini-box sm-padding margin-bottom-1">
                    <h3>{t('So geht\'s weiter:')}</h3>
                    <div className="list-item">
                        <div className="number-bg">
                            <span>1</span>
                        </div>
                        <small>{t('Öffne dein E-Mail-Postfach')}</small>
                    </div>
                    <div className="list-item">
                        <div className="number-bg">
                            <span>2</span>
                        </div>
                        <small>{t('Klicke auf den Bestätigungslink')}</small>
                    </div>
                    <div className="list-item">
                        <div className="number-bg">
                            <span>3</span>
                        </div>
                        <small>{t('Erhalte sofort Zugang zu deinem VIP Club')}</small>
                    </div>
                </div>
                <button className="btn std-height flex-align-center gap-1-half margin-bottom-1" onClick={() => window.open(`https://${domain}`)}>
                    <span className="icon--ri mail-line"></span>
                    {t('Zu')} {email?.split('@')[1]}
                </button>
                <div className="text-align-center">
                    <p className="reset-margin">{t('E-Mail nicht erhalten?')}</p>
                    <a><small>{t('Erneut senden')}</small></a>
                </div>
            </div>
        </div>
    )
}
